import {
  assign,
  sumBy,
  last,
  each,
} from 'lodash';
import { configApi } from '@/api';
import { socket } from '@/plugins';
import types from './mutationTypes';

const roundNumber = amount => +(`${Math.round(Number(`${amount}e+2`))}e-2`);

const addCommonPayload = (config, payload) => {
  assign(payload, {
    app: config.app,
  });
};

const isValidTicketPayment = (ticket) => {
  const paymentAmountRounded = roundNumber(ticket.payment);
  const sumOfPaymentsPerBet = roundNumber(sumBy(ticket.bets, bet => bet.payment));
  const paymentAmountDifference = roundNumber(paymentAmountRounded - sumOfPaymentsPerBet);

  return {
    isValid: Math.abs(paymentAmountRounded) === Math.abs(sumOfPaymentsPerBet),
    paymentAmountDifference,
  };
};

const recalculateLastTicketBetPayment = (paymentAmountDifference, ticket) => {
  const lastBet = last(ticket.bets);
  let betPayment = lastBet.payment;
  if (paymentAmountDifference) {
    betPayment += paymentAmountDifference;
    const betPaymentFormatted = betPayment.toFixed(2);
    lastBet.payment = roundNumber(betPaymentFormatted);
  }
};

export default {
  addTicketBet({ commit }, payload) {
    commit(types.ADD_TICKET_BET, payload);
  },
  clearTicket({ commit }) {
    commit(types.CLEAR_TICKET);
  },
  loadConfig({ commit, getters, dispatch }, payload) {
    addCommonPayload(getters.config, payload);
    return configApi.getConfig(payload).then((result) => {
      commit(types.SET_CONFIG, result);
      dispatch('setShortcuts');
      return getters.config;
    }).then((config) => {
      socket.init(config);
    });
  },
  setAllowedShortcut({ commit }, data) {
    commit(types.SET_ALLOWED_SHORTCUT, data);
  },
  setAuth({ commit }, payload) {
    commit(types.SET_AUTH, payload);
  },
  setShopRebetTicket({ commit, getters }, data) {
    const { round, nextRounds } = getters;
    each(data, (item) => {
      const bet = item;
      bet.payment = item.payment.toFixed(2);
      const event = nextRounds.length ? nextRounds[0].displayId : round.displayId;
      assign(bet, { event });
      commit(types.ADD_TICKET_BET, bet);
    });
  },
  setPlatform({ commit }, payload) {
    commit(types.SET_PLATFORM, payload);
  },
  setUser({ commit }, payload) {
    commit(types.SET_USER, payload);
  },
  setShortcuts({ getters, commit }) {
    const { wheelBets } = getters;
    commit(types.SET_SHORTCUTS, wheelBets);
  },
  setLimits({ commit, getters }) {
    const { channel, wheel } = getters;
    commit(types.SET_LIMITS, { channel, wheel });
  },
  updateTicket({ commit }, payload) {
    commit(types.UPDATE_TICKET, payload);
  },
  updateBet({ commit }, payload) {
    commit(types.UPDATE_BET, payload);
  },
  updateBetslipTicket({ commit }, { ticket, recalculateBetPayment }) {
    const validatedPaymentAmount = isValidTicketPayment(ticket);
    if (!validatedPaymentAmount.isValid && recalculateBetPayment) {
      recalculateLastTicketBetPayment(validatedPaymentAmount.paymentAmountDifference, ticket);
    }
    commit(types.UPDATE_BETSLIP_BET, ticket);
  },
};
